const current = new Date(); // Current time
const interval = 15; // Interval in minutes

const roundTimeToInterval = (currentTime: Date, interval: number) => {
  const minutes = currentTime.getMinutes();
  const roundedMinutes = Math.floor(minutes / interval) * interval;

  const roundedTime = new Date(currentTime);
  roundedTime.setMinutes(roundedMinutes);
  roundedTime.setSeconds(0);

  return roundedTime;
};

const formatDateTime = (dateTime: Date) => {
  const year = dateTime.getFullYear();
  const month = String(dateTime.getMonth() + 1).padStart(2, "0");
  const day = String(dateTime.getDate()).padStart(2, "0");
  const hours = String(dateTime.getHours()).padStart(2, "0");
  const minutes = String(dateTime.getMinutes()).padStart(2, "0");
  const seconds = String(dateTime.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

const roundedTime = roundTimeToInterval(current, interval);
export const formattedTime = formatDateTime(roundedTime);

// XSM-1536 - SSO Feature
/**
 * Concatenates two text parameters with colon separator and returns the base64 encoded string
 * @param text1 First text parameter
 * @param text2 Second text parameter
 * @returns Base64 encoded string
 */
export const concatAndEncodeBase64 = (text1: string, text2: string): string => {
  const concatenatedString = `${text1}:${text2}`;
  return window.btoa(concatenatedString);
};
